var ltr6_module_analytics = (function(ltr6_module_analytics) {




  function tracking_adobe(name,type,interaction,position){
    // adobe
    //     name: "<Name of the content that has been interacted with, like the name of a button or video>",
    //     type: "<Type of the content, like 'Video' or 'Button'>",
    //     interaction: "<Name of the interaction, like 'Click' or 'Play'>",
    //     position: "<Position of content on the page, especially if the same content appears multiple times, like 'Top', 'Bottom', "First", "Last", etc.>"
    var detailParams = { content:
      {
        'name': name,
        'type': type,
        'interaction': interaction,
        'position': position
      }
    }
    var adobeEvent = new CustomEvent('dhl_utf_contentInteraction', { bubbles: true, detail: detailParams});
    window.dispatchEvent(adobeEvent);
    console.log('Adobe Tracking:',name+', '+type+', '+interaction+', '+position);



  };
  function tracking_decibel(name,type,interaction,position){
    var decibelEvent = new CustomEvent('dhl_utf_trackDecibelEvent', { bubbles: true, detail: {"decibel":{"event":{"name":(name+' - type:'+type+' - interaction:'+interaction+' - position:'+position),"type":"SPA","scope":"Logistics Trend Radar 7"}}}});
    window.dispatchEvent(decibelEvent);
    console.log('Decibel Tracking:',name+', type:'+type+' ,interaction:'+interaction+', position:'+position);
  };



  function tracking_adobe_with_attributes(name,type,interaction,position,attributes){
    var detailParams = { content:
      {
        'name': name,
        'type': type,
        'interaction': interaction,
        'position': position,
        'attributes': attributes,
      }
    }
    var adobeEvent = new CustomEvent('dhl_utf_contentInteraction', { bubbles: true, detail: detailParams});
    window.dispatchEvent(adobeEvent);
    console.log('Adobe Tracking With Attributes:',name+', '+type+', '+interaction+', '+position+', '+attributes);

  };

  function tracking_decibel_with_attributes(name,type,interaction,position,attributes){
    var decibelEvent = new CustomEvent('dhl_utf_trackDecibelEvent', { bubbles: true, detail: {"decibel":{"event":{"name":(name+' - type:'+type+' - interaction:'+interaction+' - position:'+position+' - attributes:'+attributes),"type":"SPA","scope":"Logistics Trend Radar 7"}}}});
    window.dispatchEvent(decibelEvent);
    console.log('Decibel Tracking With Attributes:',name+', type:'+type+' ,interaction:'+interaction+', position:'+position+', attributes:'+attributes);
  };

  // GLOBAL


  // // external links
  // $('#fowtr-wrapper').on('click', 'a[data-ltr6-tracking-external-link]', function(event) {
  //   var name = $(this).attr('data-ltr6-tracking-external-link');
  //   tracking_adobe(name + ' External Link','Link','Click','First');
  //   tracking_decibel(name + ' External Link','Link','Click','First');
  // });


  // // internal links
  // $('#fowtr-wrapper').on('click', 'a[data-ltr6-tracking-internal-link]', function(event) {
  //   var name = $(this).attr('data-ltr6-tracking-internal-link');
  //   tracking_adobe(name + ' Internal Link','Link','Click','First');
  //   tracking_decibel(name + ' Internal Link','Link','Click','First');
  // });



  // ltr6_module_analytics.currentSectionInView = 0;

  ltr6_module_analytics.init = function() {
    // ltr6_module_analytics.currentChapter = chapter;
    // if(typeof window.ltr6_trend_name !== 'undefined') {
    //   var trend = window.ltr6_trend_name;
    //   console.log('dataLayer.page.pageInfo.pageName','Logistics Trend Radar 7 | '+trend+' | DHL');
    //   try {
    //     dataLayer.page.pageInfo.pageName = 'Logistics Trend Radar 7 | '+trend+' | DHL';
    //   } catch(e) {
    //     console.warn('Tracking dataLayer not found');
    //   }
    // } else {
    //   // console.warn('Trend name not found');
    //   dataLayer.page.pageInfo.pageName = 'Logistics Trend Radar 7 | '+trend+' | DHL';
    // }





    // if(typeof window.ltr6_dataLayer !== 'undefined') {
    //   // var trend = window.ltr6_trend_name;
    //   console.log('ltr6_dataLayer',window.ltr6_dataLayer);
    //   try {
    //     dataLayer.page.pageInfo.pageName = window.ltr6_dataLayer;
    //   } catch(e) {
    //     console.warn('AEM dataLayer not found');
    //   }
    // } else {
    //   console.warn('ltr6_dataLayer not found');
    // }

    // // page view
    // var event = new CustomEvent('dhl_utf_pageload', { bubbles: true });
    // window.dispatchEvent(event);
    // console.log('dhl_utf_pageload event triggered');




    $('#ltr6-wrapper').on('click auxclick', '[data-ltr6-tracking]', function(event) {
      var data = $(this).attr('data-ltr6-tracking');
      // data = "{'name':'name','type':'type','interaction':'interaction','position':'position','adobe':'true','decibel':'true'}";
      data = data.replace(/'/g, '"');
      data = data.replace(/'\r|\n/, '');
      data = JSON.parse(data);
      // console.log('tracking',data.name);
      if(data.adobe=='true') tracking_adobe(data.name, data.type, data.interaction, data.position);
      if(data.decibel=='true') tracking_decibel(data.name, data.type, data.interaction, data.position);
    });



    // ============================================================================
    // scroll percent tracking
    // ============================================================================
    
    var highestScrollPercent = 0;
    var pc25 = false;
    var pc50 = false;
    var pc75 = false;
    var pc100 = false;

    var scrollTracking = ltr6_module_utilities.debounce(function() {
        var s = $(window).scrollTop(),
            d = $(document).height(),
            c = $(window).height();
            f = $('#wcag-footer').height();
        var scrollPercent = (s / (d - c - f)) * 100;
        if(scrollPercent > highestScrollPercent){
          highestScrollPercent = scrollPercent;
          if(highestScrollPercent >= 100 && pc100==false) {
            tracking_adobe('Percent Scrolled','View','Milestone 100%','Page Scroll');
            tracking_decibel('Percent Scrolled','View','Milestone 100%','Page Scroll');
            pc100 = true;
            return false;
          }
          if(highestScrollPercent >= 75 && pc75==false) {
            tracking_adobe('Percent Scrolled','View','Milestone 75%','Page Scroll');
            tracking_decibel('Percent Scrolled','View','Milestone 75%','Page Scroll');
            pc75 = true;
            return false;
          }
          if(highestScrollPercent >= 50 && pc50==false) {
            tracking_adobe('Percent Scrolled','View','Milestone 50%','Page Scroll');
            tracking_decibel('Percent Scrolled','View','Milestone 50%','Page Scroll');
            pc50 = true;
            return false;
          }
          if(highestScrollPercent >= 25 && pc25==false) {
            tracking_adobe('Percent Scrolled','View','Milestone 25%','Page Scroll');
            tracking_decibel('Percent Scrolled','View','Milestone 25%','Page Scroll');
            pc25 = true;
            return false;
          }
        }
        // console.log('scrollPercent',scrollPercent);
    }, 500);
    window.addEventListener('scroll', scrollTracking);





    // guided tour
    $('#ltr6-wrapper').on('click', '.ltr6-tutorial-link', function(event) {
      event.preventDefault();
      ltr6_module_analytics.tracking_adobe('Guided Tour','Button','Click','First');
      ltr6_module_analytics.tracking_decibel('Guided Tour','Button','Click','First');
    });


    // filters accordian
    $('#ltr6-wrapper').on('click', '.ltr6-filter-groups .ltr6-filter-group .ltr6-filter-group-accordion-toggle', function(event) {
      event.preventDefault();
      var group = $(this).closest('.ltr6-filter-group');

      var groupName = group.attr('data-filter-group');
      var groupNiceName = '';
      if(groupName=='focus_area') groupNiceName = 'Focus Areas';
      if(groupName=='trend_cluster') groupNiceName = 'Trend Clusters';
      if(groupName=='sector') groupNiceName = 'Sectors';
      ltr6_module_analytics.tracking_adobe(groupNiceName,'Button','Click','Trends Filter Group');
      ltr6_module_analytics.tracking_decibel(groupNiceName,'Button','Click','Trends Filter Group');
    });

    // filters
    $('#ltr6-wrapper .ltr6-radar-filters ').on('change', '.ltr6-toggle-switch input', function(event) {
      if($(this).prop('checked')){
        var filterName = $(this).parent().find('.ltr6-label').text();
        ltr6_module_analytics.tracking_adobe(filterName,'Button','Click','Trends Filter');
        ltr6_module_analytics.tracking_decibel(filterName,'Button','Click','Trends Filter');
      }
    });


    // trend on radar
    $('#ltr6-wrapper .ltr6-radar-view').on('click', '.ltr6-node', function(event) {
      var trendNane = $(this).attr('data-trend-name');
      ltr6_module_analytics.tracking_adobe(trendNane,'Button','Click','Trend Popup (Radar)');
      ltr6_module_analytics.tracking_decibel(trendNane,'Button','Click','Trend Popup (Radar)');
    });

    // trend on grid
    $('#ltr6-wrapper .ltr6-grid-view').on('click', '.ltr6-radar-grid-block a', function(event) {
      var trendNane = $(this).parent().attr('data-trend-name');
      ltr6_module_analytics.tracking_adobe(trendNane,'Button','Click','Trend Popup (Grid)');
      ltr6_module_analytics.tracking_decibel(trendNane,'Button','Click','Trend Popup (Grid)');
    });

    // switch views
    $('#ltr6-wrapper').on('click', '.ltr6-radar-view-button-group a', function(event) {
      event.preventDefault();
      var view = $(this).attr('data-radar-view');
      var title;
      if(view=='radar') title = 'Radar View';
      if(view=='grid') title = 'Grid View';
      ltr6_module_analytics.tracking_adobe(title,'Button','Click','Switch Views');
      ltr6_module_analytics.tracking_decibel(title,'Button','Click','Switch Views');
    });

    // zoom in out etc.
    $('#ltr6-wrapper .ltr6-radar-bottom-controls').on('click', 'a[data-ltr6-panzoom-action="zoom_in"]', function(event) {
      event.preventDefault();
      ltr6_module_analytics.tracking_adobe('Zoom In','Button','Click','Radar View Controls');
      ltr6_module_analytics.tracking_decibel('Zoom In','Button','Click','Radar View Controls');
    });
    $('#ltr6-wrapper .ltr6-radar-bottom-controls').on('click', 'a[data-ltr6-panzoom-action="zoom_out"]', function(event) {
      event.preventDefault();
      ltr6_module_analytics.tracking_adobe('Zoom Out','Button','Click','Radar View Controls');
      ltr6_module_analytics.tracking_decibel('Zoom Out','Button','Click','Radar View Controls');
    });
    $('#ltr6-wrapper .ltr6-radar-bottom-controls').on('click', 'a[data-ltr6-panzoom-action="reset"]', function(event) {
      event.preventDefault();
      ltr6_module_analytics.tracking_adobe('Reset View','Button','Click','Radar View Controls');
      ltr6_module_analytics.tracking_decibel('Reset View','Button','Click','Radar View Controls');
    });



    $('#ltr6-wrapper .ltr6-feedback-button').click(function(event) {
      event.preventDefault();
      try {
        window.usabilla_live('trigger', 'ltr6_survey_trigger');
        $(this).addClass('disabled');
      } catch(e) {
        console.warn('usabilla_live not found');
      }
    });


    // read full article
    $('#ltr6-wrapper #ltr6-trend-popup').on('click auxclick', 'a.base-button', function(event) {
      var trendNane = $(this).parent().find('h4').text();


      // add attributes if filters applied start
      var radarInstance = $(this).parent().parent().parent().parent().parent().parent().parent();
      var analyticsAttributes = getActiveFiltersForAnalytics(radarInstance);
      if(analyticsAttributes){
        var radarInstanceName = 'Radar';
        // var trendNane = $(this).parent().attr('data-trend-name');
        if(radarInstance===$('#ltr6-wrapper .ltr6-navigation-radar-wrapper')) {
          radarInstanceName = 'Grid';
          trendNane = $(this).attr('data-trend-name');
        }
        analyticsAttributesObject = {"Filters Applied":analyticsAttributes};
        // console.log('analyticsAttributes',analyticsAttributes);
        // var trendNane = $(this).attr('data-trend-name');
        ltr6_module_analytics.tracking_adobe_with_attributes(trendNane,'Button','Click','Read Full Article',analyticsAttributesObject);
        ltr6_module_analytics.tracking_decibel_with_attributes(trendNane,'Button','Click','Read Full Article',analyticsAttributes);
      } else {

        ltr6_module_analytics.tracking_adobe(trendNane,'Button','Click','Read Full Article');
        ltr6_module_analytics.tracking_decibel(trendNane,'Button','Click','Read Full Article');
      }
      // end

    });

    function getActiveFiltersForAnalytics(radarInstance){
        // console.log('radarInstance',radarInstance);
      var groups = $('.ltr6-radar-filters .ltr6-filter-groups .ltr6-filter-group', radarInstance);
      var filterCount = 0;

      var focus_areas_filters = [];
      var trend_clusters_filters = [];
      var sectors_filters = [];

      // get toggle state of filter
      $.each(groups, function(index, val) {
        var group = $(this);
        var groupName = $(this).attr('data-filter-group');
        var filters = $(this).find('.ltr6-toggle-switch');
        var thisFilterCount = 0;
        $.each(filters, function(index, val) {
          // var filterName = $(this).attr('data-filter-name');
          var filterName = $(this).find('.ltr6-label').text();
          if($(this).find('input').is(":checked")){
            // console.log('ACTIVE: '+filterName);
            thisFilterCount ++;

            if(groupName=='focus_area') focus_areas_filters.push(filterName);
            if(groupName=='trend_cluster') trend_clusters_filters.push(filterName);
            if(groupName=='sector') sectors_filters.push(filterName);

          } else {
            // console.log('INACTIVE: '+filterName);
          }
        });
        filterCount += thisFilterCount;
            // console.log(thisFilterCount + 'active filters');

        var activeText = '';
        if(thisFilterCount>0){
          
        }

      });

      // focus_areas_filters = focus_areas_filters.join(", ");
      // trend_clusters_filters = trend_clusters_filters.join(", ");
      // sectors_filters = sectors_filters.join(", ");

      // console.log('focus_areas_filters',focus_areas_filters);
      // console.log('trend_clusters_filters',trend_clusters_filters);
      // console.log('sectors_filters',sectors_filters);
      var filtersAppliedText = [];
      if(focus_areas_filters.length>0) filtersAppliedText.push("Focus Areas: " + focus_areas_filters.join(", "));
      if(trend_clusters_filters.length>0) filtersAppliedText.push("Trend Clusters: " + trend_clusters_filters.join(", "));
      if(sectors_filters.length>0) filtersAppliedText.push("Sectors: " + sectors_filters.join(", "));
      // console.log('filtersAppliedText',filtersAppliedText.join(", "));
      if(filtersAppliedText.length>0){
        return filtersAppliedText.join(", ");
      } else {
        return false;
      }

    }


  }; //end init


  // expose externally
  ltr6_module_analytics.tracking_adobe = function(name,type,interaction,position){
    tracking_adobe(name,type,interaction,position);
  };
  ltr6_module_analytics.tracking_adobe_with_attributes = function(name,type,interaction,position,attributes){
    tracking_adobe_with_attributes(name,type,interaction,position,attributes);
  };
  ltr6_module_analytics.tracking_decibel = function(name,type,interaction,position){
    tracking_decibel(name,type,interaction,position);
  };
  ltr6_module_analytics.tracking_decibel_with_attributes = function(name,type,interaction,position,attributes){
    tracking_decibel_with_attributes(name,type,interaction,position,attributes);
  };


  ltr6_module_analytics.destroy = function(trend){
    // console.log('destroy chapter analytics '+trend);
  };//end destroy function


  return ltr6_module_analytics;
}(ltr6_module_analytics || {}));